
<div style="float: left; padding-top: 8px;">{{ data.message | translate }} <ng-container *ngIf="data.params">{{data.params}}</ng-container></div>
<button (click)="closeMessage()" style="float: right;" mat-icon-button>
    <mat-icon>
        close
    </mat-icon>
</button>
